// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var NavController = function ($scope, $rootScope, System) {
    getActivitiesPath();

    $scope.$on('permissions-updated', function () {
        getActivitiesPath();
    });

    $rootScope.getLogoImg = function () {
        return "/img/frisbii/logo-main-nav.svg";
    };

    if (!$rootScope.instanceName) {
        System.get({}, function (data) {
            $rootScope.instanceName = data.InstanceName;
            $rootScope.applicationVersion = data.ApplicationVersion;
        });
    }

    function getActivitiesPath() {
        if ($rootScope.adminOrInRole(["Operations", "ReadOnlyOperations"])) {
            $scope.activitiesUrl = "#/activities/reconciliation";
        } else if ($rootScope.hasRole("Reports")) {
            $scope.activitiesUrl = "#/activities/reporting";
        } else if ($rootScope.hasRole("Finance")) {
            $scope.activitiesUrl = "#/activities/accountingexport/exports";
        }
    }
};
NavController.$inject = ['$scope', '$rootScope', 'System'];
